export const m = {
    home_page: 'ᠲᠡᠷᠢᠭᠦᠨ ᠨᠢᠭᠤᠷ',//首页
    noData: 'ᠣᠳᠣᠬᠠᠨ ᠳᠠᠭᠠᠨ ᠲᠣᠭ᠎ᠠ ᠪᠠᠷᠢᠮᠲᠠ ᠦᠭᠡᠢ！',//暂无数据
    logout: 'ᠨᠡᠪᠲᠡᠷᠡᠯᠲᠠ ᠠᠴᠠ ᠭᠠᠷᠬᠤ', // 退出登陆
    content_Please: 'ᠬᠠᠶᠢᠬᠤ ᠠᠭᠤᠯᠭ᠎ᠠ ᠪᠠᠨ ᠲᠠᠭᠯᠠᠭᠠᠷᠠᠢ',//请输入要搜索的内容
    mobile_Please: 'ᠤᠳᠠᠰᠤᠨ ᠨᠣᠮᠧᠷ ᠢᠶᠡᠨ ᠡᠨᠳᠡ ᠲᠠᠭᠯᠠᠭᠠᠷᠠᠢ',//填写手机号
    telephone_Please: 'ᠵᠥᠪ ᠤᠲᠠᠰᠤᠨ ᠨᠣᠮᠧᠷ ᠢᠶᠡᠨ ᠲᠠᠭᠯᠠᠭᠠᠷᠠᠢ',//请填写正确电话号码
    code_to_frequently: 'ᠰᠢᠯᠭᠠᠨ ᠪᠠᠲᠤᠯᠠᠬᠤ ᠺᠣᠳ᠋ ᠬᠡᠲᠦ ᠣᠯᠠᠨ ᠶᠠᠪᠤᠭᠤᠯᠵᠤ ᠪᠠᠶᠢᠨ᠎ᠠ ᠂ 1 ᠴᠠᠭ ᠤᠨ ᠳᠠᠷᠠᠭ᠎ᠠ ᠳᠠᠭᠢᠵᠤ ᠲᠤᠷᠰᠢᠭᠠᠷᠠᠶ ︕',//发送验证码太频繁，请1小时后再试！
    code_is_inconsistent: 'ᠰᠢᠯᠭᠠᠨ ᠪᠠᠲᠤᠯᠠᠬᠤ ᠺᠣᠳ᠋ ᠢ ᠣᠯᠤᠭᠰᠠᠨ ᠭᠠᠷ ᠤᠲᠠᠰᠤᠨ ᠤ ᠨᠣᠮᠧᠷ ᠪᠠ ᠲᠠᠭᠯᠠᠭᠰᠠᠨ ᠭᠠᠷ ᠤᠲᠠᠰᠤᠨ ᠤ ᠨᠣᠮᠧᠷ ᠨᠢ ᠠᠳᠠᠯᠢ ᠦᠭᠡᠢ',//获取验证码手机号和输入手机号不一致
    verification_code_Please: 'ᠰᠢᠯᠭᠠᠬᠤ ᠺᠣᠳ᠋ ᠢᠶᠡᠨ ᠡᠨᠳᠡ ᠲᠠᠭᠯᠠᠭᠠᠷᠠᠢ',//请填写验证码
    collection_Please: ' ᠬᠠᠳᠠᠭᠠᠯᠠᠮᠵᠢ  ᠶᠢᠨ ᠭᠠᠵᠠᠷ  ᠢᠶᠠᠨ ᠰᠣᠩᠭᠣᠭᠠᠷᠠ',//请选择馆藏
    code_Incorrect: 'ᠰᠢᠯᠭᠠᠨ ᠪᠠᠲᠤᠯᠠᠬᠤ ᠺᠣᠳ᠋ ᠴᠢᠨᠢ ᠪᠤᠷᠤᠭᠤ',//验证码不正确
    page_away: 'ᠰᠦᠯᠵᠢᠶ᠎ᠡ  ᠲᠣᠭᠲᠠᠪᠤᠷᠢ ᠦᠭᠡᠢ ᠂ ᠤᠳᠠᠰᠬᠢᠭᠠᠳ ᠳᠠᠬᠢᠨ ᠲᠤᠷᠰᠢᠭᠠᠷᠠᠶ!',//页面溜走了，请稍后重试！


    wlgk: 'ᠲᠣᠶ᠋ᠢᠮᠣ ᠪᠠᠶ᠋ᠢᠳᠠᠯ',//文联概况
    wl_introduction: 'ᠲᠣᠪᠴᠢ ᠲᠠᠨᠢᠯᠴᠠᠭᠤᠯᠭ᠎ᠠ ',//文联简介
    wl_constitution: 'ᠵᠢᠷᠤᠮ ',//文联章程
    wl_leader: 'ᠤᠳᠤᠷᠢᠳᠤᠯᠭ᠎ᠠ ᠵᠢᠨ ᠪᠠᠭ',//文联领导
    Organization: 'ᠪᠠᠶ᠋ᠢᠭᠤᠯᠤᠯ',//组织机构
    infor_disclosure: 'ᠮᠡᠳᠡᠭᠡ',//信息公开
    Work_dynamics: 'ᠠᠵᠢᠯ ᠊ᠤᠨ ᠪᠠᠶ᠋ᠢᠳᠠᠯ',//工作动态
    Notice_ann: 'ᠮᠡᠳᠡᠭᠳᠡᠯ',//通知公告
    Party_work: 'ᠨᠠᠮ ᠊ᠤᠨ ᠠᠵᠢᠯ',//党建工作
    wenyijs: 'ᠤᠳᠬ᠎ᠠ ᠤᠷᠠᠯᠢᠭ ᠊ᠤᠨ ᠰᠣᠨᠢᠷᠬᠠᠮᠵᠢ',//文艺鉴赏
    wyjxh: 'ᠤᠳᠬ᠎ᠠ ᠤᠷᠠᠯᠢᠭᠴᠢᠳ ᠤᠨ  ᠨᠡᠶ᠋ᠢᠭᠡᠮᠯᠢᠭ',//文艺家协会

    wenyj: ' ᠤᠳᠬ᠎ᠠ ᠤᠷᠠᠯᠢᠭᠴᠢᠳ',//文艺家
    dzqk: 'ᠴᠠᠬᠢᠮ ᠰᠡᠳᠬᠦᠯ',//电子期刊
    yqqh: 'ᠬᠡᠯᠡ',//语言切换
    sousuo: ' ᠬᠠᠶ᠋ᠢᠯᠲᠠ',//搜索
    denglu: 'ᠨᠡᠪᠲᠡᠷᠡᠬᠦ ',//登录
    zhuce: 'ᠪᠦᠷᠢᠳᠬᠡᠭᠦᠯᠬᠦ',//注册
    source: 'ᠢᠷᠡᠯᠲᠡ ',//来源
    details: 'ᠨᠠᠷᠢᠨ ᠠᠭᠤᠯᠭ᠎ᠠ',//详情
    Personal_Center: 'ᠬᠤᠪᠢ ᠬᠥᠮᠦᠨ  ᠦ ᠲᠦᠪ',//个人中心

    searc_content: ' ᠬᠠᠶ᠋ᠢᠬᠤ ᠠᠭᠤᠯᠭ᠎ᠠ ᠪᠠᠨ ᠲᠠᠭᠯᠠᠭᠠᠷᠠᠢ',//填写搜索内容
    search_reter: 'ᠬᠠᠶᠢᠯᠲᠠ  ᠶᠢᠨ ᠦᠷ᠎ᠡ ᠳ᠋ᠦᠩ ',//搜索结果

    my_jy: 'ᠵᠠᠬᠢᠶᠠᠯᠠᠭ᠎ᠠ ',//我的交易
    oredr_gl: 'ᠮᠢᠨᠤ ᠵᠠᠬᠢᠶᠠᠯᠠᠭ᠎ᠠ ',//订单管理
    czcontent: 'ᠪᠦᠲᠦᠭᠡᠬᠦ ᠲᠥᠪ ',//创作中心
    my_works: 'ᠮᠢᠨᠤ ᠪᠦᠲᠦᠭᠡᠯ',//我的作品

    my_qb: 'ᠮᠢᠨᠤ ᠵᠣᠭᠣᠰᠤᠨ ᠪᠣᠭᠴᠣ᠌ ',//我的钱包
    my_sy: 'ᠮᠢᠨᠤ ᠠᠰᠢᠭ᠋ ᠣᠷᠣᠯᠭ᠎ᠠ ',//我的收益
    my_zh: 'ᠮᠢᠨᠤ ᠲᠤᠬᠠᠢ',//我的账号
    my_zl: 'ᠮᠢᠨᠤ ᠲᠤᠬᠠᠢ',//我的资料
    yswl: 'ᠮᠠᠨ᠎ᠤ ᠲᠤᠬᠠᠢ',//云上文联
    aboutmn: 'ᠣᠲᠣᠭ ᠦᠨ ᠡᠮᠦᠨᠡᠲᠦ ᠬᠣᠰᠢᠭᠤᠨ ᠦ ᠤᠳᠬ᠎ᠠ ᠤᠷᠠᠯᠢᠭ ᠦᠨ ᠬᠢᠨ ᠦ ᠬᠣᠯᠪᠣᠭ᠎ᠠ ',//关于我们
    allworks: 'ᠪᠥ᠋ᠬᠦ ᠪᠦᠲᠦᠭᠡᠯ',//全部作品

    jiage: 'ᠦᠨ᠎ᠡ ',//价格
    ordersture: 'ᠵᠠᠬᠢᠶᠠᠯᠠᠭ᠎ᠠ ᠵᠢᠨ ᠪᠠᠶ᠋ᠢᠳᠠᠯ',//订单状态
    wordes_num: 'ᠪᠦᠲᠦᠭᠡᠯ  ᠤᠨ ᠨᠣᠮᠧᠷ',//作品编号
    puch_time: 'ᠨᠡᠢᠲᠡᠯᠡᠭᠰᠡᠨ ᠴᠠᠭ',//发布时间
    works_zp: 'ᠪᠦᠲᠦᠭᠡᠯ  ᠦᠨ ᠨᠡᠷ᠎ᠡ ',//作品
    order_number: 'ᠵᠠᠬᠢᠶᠠᠯᠠᠭ᠎ᠠ ᠵᠢᠨ ᠳ᠋ᠤᠭᠠᠷ',//订单编号
    edit_works: 'ᠨᠠᠶ᠋ᠢᠷᠠᠭᠤᠯᠬᠤ',//编辑作品
    delet_works: 'ᠪᠦᠲᠦᠭᠡᠯ ᠊ᠢ ᠬᠠᠰᠤᠬᠤ',//删除作品

    works_sture: 'ᠪᠠᠷᠠᠭ᠎ᠠ ᠪᠡᠯᠡᠨ ᠡᠰᠡᠬᠦ',//作品状态
    nowc: 'ᠳᠠᠭᠤᠰᠤᠭ᠎ᠠ ᠦᠭᠡᠢ ᠵᠠᠬᠢᠶᠠᠯᠠᠭ᠎ᠠ',//未完成
    yeswc: 'ᠠᠮᠵᠢᠯᠲᠠᠲᠠᠢ ᠵᠠᠬᠢᠶᠠᠯᠠᠭ᠎ᠠ',//已完成
    order_details: ' ᠵᠠᠬᠢᠶᠠᠯᠠᠭ᠎ᠠ ᠵᠢᠨ ᠮᠡᠳᠡᠭᠡᠯᠡᠯ',//订单详情
    dowonl: 'ᠠᠰᠢᠭᠯᠠᠭᠰᠠᠨ ᠲᠣᠭ᠎ᠠ',//下载量
    check_sy: 'ᠣᠷᠣᠯᠭ᠎ᠠ',//查看收益
    xj_work: ' ᠳᠠᠭᠤᠰᠤᠭᠰᠠᠨ ᠪᠠᠷᠠᠭ᠎ᠠ',//下架作品
    totle_works: 'ᠪᠦᠲᠦᠭᠡᠯ ᠊ᠦᠨ ᠬᠠᠳᠠᠭᠠᠯᠠᠯᠲᠠ',//总作品收藏
    jd_works: 'ᠰᠣᠩᠭᠣᠳᠠᠭ ᠪᠦᠲᠦᠭᠡᠯ ᠊ᠦᠳ',//经典藏品
    cynum: ' ᠨᠡᠶ᠋ᠢᠲᠡ ᠭᠡᠰᠢᠭᠦᠨ',//成员人数
    works_num: ' ᠨᠡᠶ᠋ᠢᠲᠡ ᠪᠦᠲᠦᠭᠡᠯ',//作品数量
    gzdy: 'ᠠᠵᠢᠯ ᠊ᠤᠨ ᠪᠠᠶ᠋ᠢᠳᠠᠯ',//工作动态
    tzgg: ' ᠮᠡᠳᠡᠭᠳᠡᠯ',//通知公告
    gend_more: 'ᠨᠡᠩ ᠤᠯᠠᠨ',//更多

    atuor: 'ᠪᠦᠲᠦᠭᠡᠯ ᠦ᠋ᠨ ᠵᠣᠬᠢᠶᠠᠭ᠍ᠴᠢ',//作者

    jj: 'ᠲᠣᠪᠴᠢ ᠲᠠᠨᠢᠯᠴᠠᠭᠤᠯᠭ᠎ᠠ ',//简介
    b: ' ᠲᠥᠭᠥᠷᠢᠭ ',//币
    works_downl: 'ᠪᠦᠲᠦᠭᠡᠯ ᠎ᠢ ᠪᠠᠭᠤᠯᠭᠠᠬᠤ',//作品下载
    xg_book: 'ᠬᠣᠯᠪᠣᠭᠳᠠᠬᠤ ᠰᠡᠳᠬᠦᠯ ',//相关数据
    cbs: 'ᠬᠡᠪᠯᠡᠯ ᠦ᠋ᠨ ᠬᠣᠷᠢᠶ᠎ᠠ ',//出版社

    works_class: 'ᠪᠦᠲᠦᠭᠡᠯ  ᠤᠨ ᠠᠩᠭᠢᠯᠠᠯ ',//作品分类
    pl_works_class: 'ᠪᠦᠲᠦᠭᠡᠯ᠎ᠦᠨ ᠠᠩᠭᠢᠯᠠᠯ',//请选择作品分类
    works_title: 'ᠪᠦᠲᠦᠭᠡᠯ  ᠦᠨ ᠨᠡᠷ᠎ᠡ ',//作品标题
    pl_works_title: 'ᠪᠦᠲᠦᠭᠡᠯ  ᠦᠨ ᠨᠡᠷ᠎ᠡ    ᠶᠢ  ᠲᠠᠭᠠᠯᠠᠨ',//填写作品标题
    yulan: ' ᠤᠷᠢᠳᠴᠢᠯᠠᠨ ᠦᠵᠡᠬᠦ',//预览
    photo: ' ᠵᠢᠷᠤᠭ',//图片
    video: 'ᠪᠢᠴᠢᠯᠭᠡ',//视频
    audio: 'ᠳᠠᠭᠤᠲᠤ ᠪᠢᠴᠢᠯᠭᠡ ',//音频
    pl_yulantype: 'ᠤᠷᠢᠳᠴᠢᠯᠠᠨ ᠦᠵᠡᠬᠦ ᠬᠡᠪ ᠵᠢᠠᠨ ᠰᠣᠩᠭᠣᠨ᠎ᠠ ᠊ᠤᠤ',//请选择预览类型
    pl_yulanwj: ' ᠹᠠᠶ᠋ᠢᠯ ᠵᠢᠠᠨ ᠰᠣᠩᠭᠣᠵᠤ ᠣᠷᠣᠭᠤᠯᠤᠨ᠎ᠠ ᠊ᠤᠤ',//请选择上传预览文件
    danj: 'ᠨᠢᠭᠡ ᠳᠠᠷᠤᠬᠤ ᠪᠤᠶᠤ ᠡᠶ᠋ᠢᠰᠢ  ᠪᠡᠨ ᠲᠠᠲᠠᠵᠤ ᠣᠷᠣᠭᠤᠯᠤᠭᠠᠷᠠᠢ',//单击或拖动此处的文件以上载
    works_autor: 'ᠪᠦᠲᠦᠭᠡᠯ ᠦ᠋ᠨ ᠵᠣᠬᠢᠶᠠᠭᠴᠢ',//作品作者
    addworks_autor: 'ᠵᠣᠬᠢᠶᠠᠭᠴᠢ  ᠶᠢ  ᠲᠠᠭᠠᠯᠠᠨ',//填写作品作者
    lxdh: 'ᠬᠠᠷᠢᠯᠴᠠᠬᠤ ᠤᠲᠠᠰᠤ ',//联系电话
    pl_lxdh: 'ᠬᠠᠷᠢᠯᠴᠠᠬᠤ ᠤᠲᠠᠰᠤ ᠤᠲᠠᠰᠤ  ᠪᠠᠨ ᠲᠠᠭᠠᠯᠠᠨ',//请填写联系电话
    pl_lxdh_no: 'ᠤᠲᠠᠰᠤᠨ  ᠳ᠋ᠤᠭᠠᠷ ᠊ᠤᠨ ᠵᠠᠭᠪᠤᠷ ᠪᠤᠷᠤᠭᠤ ᠪᠠᠶ᠋ᠢᠨ᠎ᠠ',//手机号码格式不正确
    bqsy: 'ᠬᠡᠪᠯᠡᠯ  ᠦᠨ ᠡᠷᠬᠡ ᠶᠢᠨ ᠥᠮᠴᠢᠯᠡᠭᠴᠢ',//版权所有
    pl_bqsy: 'ᠬᠡᠪᠯᠡᠯ  ᠦᠨ ᠡᠷᠬᠡ ᠶᠢᠨ ᠥᠮᠴᠢᠯᠡᠭᠴᠢ  ᠶᠢ  ᠲᠠᠭᠠᠯᠠᠨ',//请添加版权所有
    bqnum: 'ᠬᠡᠪᠯᠡᠯ ᠦᠨ ᠡᠷᠬᠡ ᠶᠢᠨ ᠳ᠋ᠤᠭᠠᠷ ',//版权号
    pl_bqnum: 'ᠬᠡᠪᠯᠡᠯ ᠦᠨ ᠡᠷᠬᠡ ᠶᠢᠨ ᠳ᠋ᠤᠭᠠᠷ ᠢ ᠲᠠᠭᠠᠯᠠᠨ',//请添加版权号
    szdq: 'ᠭᠠᠵᠠᠷ ᠣᠷᠣᠨ',//所在地区
    works_gs: ' ᠪᠦᠲᠦᠭᠡᠯ  ᠤᠨ ᠬᠡᠯᠪᠡᠷᠢ',//作品格式
    works_size: 'ᠪᠦᠲᠦᠭᠡᠯ  ᠤᠨ ᠶᠡᠬᠡ ᠪᠠᠭ᠎ᠠ ',//作品大小
    jianj: 'ᠪᠦᠲᠦᠭᠡᠯ  ᠦᠨ ᠲᠠᠨᠢᠯᠴᠠᠭᠤᠯᠭ᠎ᠠ',//作品简介
    pl_jianj: 'ᠪᠦᠲᠦᠭᠡᠯ  ᠦᠨ ᠲᠠᠨᠢᠯᠴᠠᠭᠤᠯᠭ᠎ᠠ  ᠶᠢ ᠲᠠᠭᠠᠯᠠᠨ ',//添加作品简介
    sytype: 'ᠠᠰᠢᠭ ᠣᠷᠣᠯᠭ᠎ᠠ ᠶᠢᠨ ᠲᠦᠷᠦᠯ ᠵᠦᠢᠯ',//收益类型
    mw: 'ᠦᠨ᠎ᠡ ᠲᠥᠯᠥᠪᠦᠷᠢ ᠦᠭᠡᠢ ᠪᠦᠲᠦᠭᠡᠯ ',//免费作品
    sw: 'ᠰᠦᠢᠳᠬᠡᠯ ᠬᠤᠷᠢᠶᠠᠬᠤ ᠪᠦᠲᠦᠭᠡᠯ',//收费作品
    shoujia: 'ᠪᠦᠲᠦᠭᠡᠯ  ᠦᠨ ᠦᠨ᠎ᠡ ',//作品价格
    up_works: 'ᠰᠢᠰᠲ᠋ᠧᠮ ᠳᠦ ᠪᠦᠲᠦᠭᠡᠯ ᠨᠡᠮᠡᠬᠦ',//上传作品
    upfj: 'ᠳᠠᠭᠠᠯᠳᠤᠪᠤᠷᠢ ᠮᠠᠲ᠋ᠧᠷᠢᠶᠠᠯ ᠢ ᠳᠡᠭᠡᠭᠰᠢ ᠳᠠᠮᠵᠢᠭᠤᠯᠬᠤ',//上传附件
    pl_upfj: 'ᠳᠠᠭᠠᠯᠲᠠ ᠮᠠᠲ᠋ᠸᠷᠢᠶᠠᠯ ᠵᠢᠠᠨ  ᠣᠷᠣᠭᠤᠯᠤᠨ᠎ᠠ ᠊ᠤᠤ',//请上传附件
    ru: 'ᠵᠢᠱᠢᠶ᠎ᠡ : ',//如
    hq_code: 'ᠰᠢᠯᠭᠠᠬᠤ ᠺᠣᠳ᠋ ᠢ ᠢᠯᠡᠭᠡᠬᠦ',//获取验证码
    all_souy: 'ᠪᠦᠬᠦ ᠣᠷᠣᠯᠭ᠎ᠠ  ',//全部收益
    downl_time:'ᠲᠠᠲᠠᠵᠤ ᠠᠪᠤᠭᠰᠠᠨ ᠴᠠᠭ   ',//下载日期
    edit_infor:'ᠮᠡᠳᠡᠭᠡᠯᠡᠯ ᠊ᠢ ᠵᠠᠰᠠᠬᠤ  ',//修改信息
    zuce_time:'ᠪᠦᠷᠢᠳᠬᠡᠭᠦᠯᠦᠭᠰᠡᠨ ᠴᠠᠭ  ',//注册时间
    tuic:'ᠨᠡᠪᠲᠡᠷᠡᠯᠲᠡ ᠠ᠋ᠴᠠ ᠭᠠᠷᠬᠤ ',//退出登录
    deng:'ᠬᠦᠯᠢᠶᠡᠬᠦ ',//等
    miao:'  ᠮᠢᠨᠦ᠋ᠲ',//秒
    goodsInfo_all: 'ᠪᠦᠬᠦᠲᠡ',//全部

    notLogin:'ᠲᠠᠨ ᠊ᠤ  ᠪᠦᠷᠢᠳᠬᠡᠭᠦᠯᠦᠭᠰᠡᠨ  ᠳ᠋ᠤᠭᠠᠷ ᠨᠡᠪᠲᠡᠷᠡᠭᠡ ᠦᠭᠡᠢ  ᠪᠠᠶ᠋ᠢᠨ᠎ᠠ᠂ ᠨᠡᠪᠲᠡᠷᠡᠨ᠎ᠡ ᠊ᠦᠦ⁉',//您还没有登录，请前往登录
    ispay:'ᠲᠤᠰ ᠪᠦᠲᠦᠭᠡᠯ ᠊ᠢ ᠬᠤᠳᠠᠯᠳᠤᠨ ᠠᠪᠬᠤ ᠬᠡᠷᠡᠭᠲᠡᠢ᠂  ᠬᠤᠳᠠᠯᠳᠤᠨ ᠠᠪᠬᠤ ᠊ᠤᠤ',//此作品需要购买，是否进行支付
    isWorksnoturl:'ᠲᠤᠰ ᠪᠦᠲᠦᠭᠡᠯ ᠨᠢ ᠲᠠᠲᠠᠵᠤ ᠠᠪᠬᠤ ᠳᠠᠭᠠᠯᠲᠠ ᠮᠠᠲ᠋ᠧᠷᠢᠶᠠᠯ ᠪᠠᠶ᠋ᠢᠬᠤ ᠦᠭᠡᠢ',//此作品没有下载的附件
    paySusee:'ᠲᠥᠯᠥᠪᠦᠷᠢ ᠠᠮᠵᠢᠯᠲᠠᠲᠠᠢ ᠪᠣᠯᠪᠠ',//支付成功
    isworknotPay:'ᠲᠤᠰ ᠪᠦᠲᠦᠭᠡᠯ ᠊ᠢ ᠲᠥᠯᠥᠪᠦᠷᠢ ᠥᠬᠡᠢ ᠰᠢᠭᠤᠳ ᠠᠰᠢᠭᠯᠠᠵᠤ ᠪᠣᠯᠤᠨ᠎ᠠ',//此作品为免费作品，无需支付
    plsugjc:'ᠲᠦᠯᠬᠢᠭᠦᠷ ᠦᠭᠡ  ᠪᠡᠨ ᠣᠷᠣᠭᠤᠯᠤᠨ᠎ᠠ ᠊ᠤᠤ',//请输入关键词
    xgsuee:'ᠠᠮᠵᠢᠯᠲᠠᠲᠠᠢ  ᠵᠠᠰᠠᠪᠠ᠂ ᠳᠠᠬᠢᠨ ᠨᠡᠪᠲᠡᠷᠡᠨ᠎ᠡ ᠊ᠦᠦᠠᠮᠵᠢᠯᠲᠠᠲᠠᠢ  ᠵᠠᠰᠠᠪᠠ᠂ ᠳᠠᠬᠢᠨ ᠨᠡᠪᠲᠡᠷᠡᠨ᠎ᠡ ᠊ᠦᠦ',//修改成功，请重新登录
    outsuee:'ᠨᠠᠪᠲᠠᠷᠠᠯᠲᠠ ᠠ᠋ᠴᠠ ᠭᠠᠷᠪᠠ',//退出成功
    plxtype:' ᠪᠦᠲᠦᠭᠡᠯ ᠊ᠦᠨ ᠲᠥᠷᠥᠯ ᠵᠢᠠᠨ ᠰᠣᠩᠭᠣᠨ᠎ᠠ ᠊ᠦᠦ',//请输选择作品分类
    plworkstitle:'ᠪᠦᠲᠦᠭᠡᠯ ᠊ᠦᠨ ᠨᠡᠷ᠎ᠡ ᠶ᠋ᠢ ᠣᠷᠣᠭᠤᠯᠤᠭᠠᠷᠠᠢ',//请输入作品标题
    plyltype:' ᠤᠷᠢᠳᠴᠢᠯᠠᠨ ᠬᠠᠷᠠᠬᠤ ᠬᠡᠯᠪᠡᠷᠢ  ᠪᠡᠨ ᠰᠣᠩᠭᠣᠭᠠᠷᠠᠢ',//请选择预览类型
    platuor:'ᠵᠣᠬᠢᠶᠠᠭᠴᠢ  ᠶ᠋ᠢ ᠣᠷᠣᠭᠤᠯᠤᠭᠠᠷᠠᠢ',//请输入作者
    pupfile:'ᠳᠠᠭᠠᠯᠲᠠ ᠮᠠᠲ᠋ᠧᠷᠢᠶᠠᠯ ᠊ᠢ ᠣᠷᠣᠭᠤᠯᠤᠭᠠᠷᠠᠢ',//请上传附件
    pltel:'ᠤᠲᠠᠰᠤᠨ  ᠳ᠋ᠤᠭᠠᠷ ᠵᠢᠠᠨ ᠲᠠᠭᠯᠠᠭᠠᠷᠠᠢ',//请输入手机号
    filetel:" ᠤᠲᠠᠰᠤᠨ  ᠳ᠋ᠤᠭᠠᠷ ᠊ᠤᠨ ᠵᠠᠭᠪᠤᠷ ᠪᠤᠷᠤᠭᠤ ᠪᠠᠶ᠋ᠢᠨ᠎ᠠ",//手机号码格式不正确
    pupYlfile:' ᠤᠷᠢᠳᠴᠢᠯᠠᠨ ᠬᠠᠷᠠᠬᠤ ᠹᠠᠶ᠋ᠢᠯ ᠵᠢᠠᠨ ᠣᠷᠣᠭᠤᠯᠤᠭᠠᠷᠠᠢ',//请上传预览文件
    editorSuecc:' ᠠᠮᠵᠢᠯᠲᠠᠲᠠᠢ ᠨᠠᠶ᠋ᠢᠷᠠᠭᠤᠯᠪᠠ',//编辑成功
    upSuecc:'ᠠᠮᠵᠢᠯᠲᠠᠲᠠᠢ ᠣᠷᠣᠭᠤᠯᠪᠠ',//上传成功
    filemorone:' ᠬᠠᠮᠤᠭ ᠊ᠤᠨ ᠣᠯᠠᠨ ᠳ᠋ᠤ᠌ ᠪᠠᠨ ᠭᠠᠭᠴᠠ ᠹᠠᠶ᠋ᠢᠯ ᠣᠷᠣᠭᠤᠯᠵᠤ ᠪᠣᠯᠤᠨ᠎ᠠ',//文件最多上传一个
    gsnot:'ᠬᠡᠯᠪᠡᠷᠢ ᠪᠤᠷᠤᠭᠤᠳᠠᠪᠠ',//格式不正确
    upsize:' ᠹᠠᠶ᠋ᠢᠯ ᠊ᠤᠨ ᠬᠠᠮᠤᠭ ᠊ᠤᠨ ᠶᠡᠬᠡ ᠬᠡᠮᠵᠢᠶ᠎ᠡ 300MB ',//上传最大不能超过300MB
    plupzip:'zip  ᠬᠡᠯᠪᠡᠷᠢ ᠵᠢᠨ ᠹᠠᠶ᠋ᠢᠯ ᠪᠠᠶ᠋ᠢᠬᠤ ᠬᠡᠷᠡᠭᠲᠡᠢ',//请上传zip格式文件
    dej:'ᠠᠮᠵᠢᠯᠲᠠᠲᠠᠢ ᠪᠠᠭᠤᠯᠭᠠᠪᠠ',//下架成功
    sccg:' ᠠᠮᠵᠢᠯᠲᠠᠲᠠᠢ ᠤᠰᠠᠳᠬᠠᠪᠠ',//删除成功
}
